import { fetchCSRFToken, getCSRFToken } from "./csrf";

export async function saveLanguagePreference(lang, options = {}) {
  if (!lang) {
    return false;
  }

  const { i18n, skipI18n = false } = options;

  if (!skipI18n && i18n && typeof i18n.changeLanguage === "function") {
    i18n.changeLanguage(lang);
  }

  localStorage.setItem("selectedLanguage", lang);

  try {
    let csrfToken = getCSRFToken();

    if (!csrfToken) {
      try {
        await fetchCSRFToken();
        csrfToken = getCSRFToken();
      } catch (error) {
        console.debug("CSRF token not available for language save:", error);
      }
    }

    const headers = {
      "Content-Type": "application/json",
    };

    if (csrfToken) {
      headers["X-CSRFToken"] = csrfToken;
    }

    const response = await fetch("/api/v1/user-profile/current", {
      method: "PATCH",
      credentials: "include",
      headers,
      body: JSON.stringify({ language: lang }),
    });

    if (response.ok) {
      return true;
    }

    if ([401, 403, 404].includes(response.status)) {
      return false;
    }

    throw new Error(`Failed to save language preference: ${response.status}`);
  } catch (error) {
    console.warn("Language preference could not be saved to backend:", error);
    return false;
  }
}
